export const TASK_QUEUE_TAB_KEYS = {
  ACTIVE: 'active',
  CONTROLS: 'controls',
  FAILURES: 'failures',
  PENDING: 'pending',
} as const;
